<template lang="pug">
  .container
    .row
      .col-md-12
        h2 {{lang['Enable / Disable Screens']}}
      .col-md-12.alert.alert-warning(v-if="warning")
        h4 {{lang['Request unsuccesfull']}}
        h4 {{lang['Kiosks listed below do not have required soft.']}}:
        p {{warning}}
      .col-md-12
        p {{lang['Insert kiosks id list']}}
        p {{lang['Correct date example']}}:
        pre 203091Kiosk1,203091Kiosk2,203091Kiosk3,203091Kiosk4
        hr
        pre 203091Kiosk1;203091Kiosk2;203091Kiosk3;203091Kiosk4
        hr
        pre 203091Kiosk1<br>203091Kiosk2<br>203091Kiosk3<br>203091Kiosk4
        textarea.form-control(rows="13" v-model="devices")
    .row(v-if="!saving")
      .col-md-6
        button.btn.btn-default.btn-danger(@click.prevent="enableDevices(false)") {{lang['Deactivate']}}
      .col-md-6
        button.btn.btn-default.btn-success.pull-right(@click.prevent="enableDevices(true)") {{lang['Activate']}}
    .row(v-if="saving")
      .col-md-12
        p.text-center {{lang['Proccessing. Please wait.']}}
</template>
<script>
export default {
  name: 'matrix',
  props: ['lang'],
  data () {
    return {
      nameRegex: /^\d{6}Kiosk\d{1,2}$/,
      saving: false,
      warning: null,
      devices: ''
    }
  },
  methods: {
    enableDevices (enable) {
      const listOfDevices = this.prepareDevices(this.devices)
      this.saving = true
      this.warning = null
      if (!this.validate(listOfDevices)) {
        this.saving = false
        return this.$notify(this.lang['Kiosk id/names are invalid'], 'error')
      }
      this.$http.patch('device/enable/', {enable, devicesNames: listOfDevices})
        .then(response => {
          console.log(response)
          if (response.status === 200) {
            if (response.body.notChangedDevices.length) {
              this.warning = response.body.notChangedDevices.join(', ')
              return this.$notify(this.lang['Not all requests sent'], 'warning', {permanent: true})
            } else {
              return this.$notify(this.lang['Request sent.'], 'success')
            }
          }
          return this.$notify(`${this.lang['Error occured']}: ${response.statusText}`, 'error', {permanent: true})
        })
        .catch(error => {
          console.error(error)
          return this.$notify(`${this.lang['Error occured']}: ${error.statusText}. ${error.bodyText}`, 'error', {permanent: true})
        })
        .finally(() => {
          this.saving = false
          this.devices = ''
        })
    },
    prepareDevices (str) {
      str = str.trim()
      const commas = str.split(',')
      const semicolons = str.split(';')
      const newLines = str.split('\n')
      let result = null
      switch (true) {
        case (commas.length > 1):
          result = commas
          break
        case (semicolons.length > 1):
          result = semicolons
          break
        default:
          result = newLines
          break
      }
      return result
    },
    validate (names) {
      for (let index = 0; index < names.length; index++) {
        if (!this.nameRegex.test(names[index])) {
          return false
        }
      }
      return true
    }
  }
}
</script>
<style lang="sass" scoped>
.row
  margin-bottom: 20px
</style>



// WEBPACK FOOTER //
// src/components/device/EnableDevices.vue